import {
  FEATURE_GATES,
  hasPermission,
  hasActiveFeatureGate
} from '@ubisend/pulse-auth';

import GenerativeAi from './Pages/GenerativeAi';
import Sitemap from './Pages/Sitemap';
import Document from './Pages/Document';
import SharePoint from './Pages/SharePoint';
import Zendesk from './Pages/Zendesk';

const canViewGenerativeAI = () =>
  hasActiveFeatureGate(FEATURE_GATES.GENERATIVE_AI) &&
  hasPermission('view generative ai');

const canViewResource = () =>
  hasActiveFeatureGate(FEATURE_GATES.GENERATIVE_AI) &&
  hasPermission('view generative ai resource');

const routes = [
  {
    path: '/generative-ai',
    component: GenerativeAi,
    name: 'Generative AI',
    canAccess: canViewGenerativeAI
  },
  {
    path: '/generative-ai/sitemap',
    component: Sitemap,
    name: 'Sitemap',
    canAccess: canViewResource
  },
  {
    path: '/generative-ai/document',
    component: Document,
    name: 'Document',
    canAccess: canViewResource
  },
  {
    path: '/generative-ai/sharepoint',
    component: SharePoint,
    name: 'SharePoint',
    canAccess: () =>
      canViewResource() &&
      hasActiveFeatureGate(FEATURE_GATES.GENERATIVE_AI_SHAREPOINT)
  },
  {
    path: '/generative-ai/zendesk',
    component: Zendesk,
    name: 'Zendesk',
    canAccess: () =>
      canViewResource() &&
      hasActiveFeatureGate(FEATURE_GATES.GENERATIVE_AI_ZENDESK)
  }
];

export default routes;